import React from "react";
import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "1. Return Window",
    body: [
      "Because many of our products are food items, returns are limited and assessed carefully.",
      "If there is a problem with your order, please contact us as soon as possible, ideally within 24 hours of delivery.",
    ],
    items: [
      "Report issues quickly",
      "Keep items in their delivered condition where possible",
      "Perishable items are reviewed case by case",
    ],
  },
  {
    title: "2. Eligible Issues",
    body: [
      "You may be eligible for a replacement, refund, or store credit if the order is damaged, incorrect, spoiled, or does not match what you received.",
      "We may request photos or other details to help us verify the issue and resolve it fairly.",
    ],
    items: [
      "Damaged or spoiled items",
      "Wrong or missing items",
      "Product quality issues",
      "Items that differ from the order summary",
    ],
  },
  {
    title: "3. Refunds and Resolution",
    body: [
      "Approved refunds are issued to the original payment method where possible.",
      "In some cases, we may offer replacement items or store credit instead of a refund.",
    ],
  },
  {
    title: "4. Non-Returnable Situations",
    body: [
      "We may decline a return request where the issue was caused by incorrect customer details, late reporting, or mishandling after delivery.",
      "Opened, consumed, or tampered items may also be ineligible unless there is a confirmed quality issue.",
    ],
  },
];

const ReturnPolicyPage = () => {
  return (
    <PolicyPageLayout
      title="Return Policy"
      intro="This Return Policy explains how Zea Mays Foods handles food-related returns, replacements, and refunds when something goes wrong with an order."
      sections={sections}
      contactEmail="zeamaysfood@gmail.com"
      contactPhone="+2347037038448"
      lastUpdated="July 14, 2026"
    />
  );
};

export default ReturnPolicyPage;
